import { render } from "./AccountingCostUpdater.vue?vue&type=template&id=e8ca82d4"
import script from "./AccountingCostUpdater.vue?vue&type=script&lang=js"
export * from "./AccountingCostUpdater.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Products/AccountingCostUpdater.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e8ca82d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e8ca82d4', __exports__)) {
    api.reload('e8ca82d4', __exports__)
  }
  
  module.hot.accept("./AccountingCostUpdater.vue?vue&type=template&id=e8ca82d4", () => {
    api.rerender('e8ca82d4', render)
  })

}


export default __exports__